<!-- Task Progress Bar -->
<div class="progress-section">
  <div class="progress-header">
    <div class="progress-info">
      <span class="progress-label">
        Task Progress
        @if (startTime) {
          <span class="timing-info"> | Started: {{ startTime | date: 'short' }} ({{ elapsedTime }}) </span>
        }
        @if (isCompleted && endTime) {
          <span class="completion-info">| Completed: {{ endTime | date: 'short' }}</span>
        }
        @if (isFailed && endTime) {
          <span class="completion-info">| Failed: {{ endTime | date: 'short' }}</span>
        }
        @if (isCancelled && endTime) {
          <span class="completion-info">| Cancelled: {{ endTime | date: 'short' }}</span>
        }
      </span>
      <span class="progress-percentage">{{ getAdjustedProgress() }}%</span>
    </div>
  </div>
  <mat-progress-bar mode="determinate" [value]="getAdjustedProgress()" class="overall-progress-bar"></mat-progress-bar>
</div>

<!-- Server Warm-up Status (shown when progress is 0 but task is running) -->
@if (isQueuing()) {
  <div class="queuing-status">
    <div class="queuing-header">
      <mat-icon class="status-icon spinning">whatshot</mat-icon>
      <h4>
        🔥 Server warm-up
        @if (queuingElapsedTime) {
          <span class="elapsed-time">({{ queuingElapsedTime }})</span>
        }
      </h4>
    </div>
    <mat-progress-bar mode="indeterminate" class="queuing-progress-bar"></mat-progress-bar>
    <p class="queuing-description">
      Initializing job processor and warming up services (typically 1-2 minutes for cold start).
    </p>
  </div>
}
